import { render } from "./StakeLiquidCompare.vue?vue&type=template&id=76066cda"
import script from "./StakeLiquidCompare.vue?vue&type=script&lang=js"
export * from "./StakeLiquidCompare.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/StakeLiquidCompare.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76066cda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76066cda', __exports__)) {
    api.reload('76066cda', __exports__)
  }
  
  module.hot.accept("./StakeLiquidCompare.vue?vue&type=template&id=76066cda", () => {
    api.rerender('76066cda', render)
  })

}


export default __exports__